module.exports = __webpack_public_path__ + "img/page-03.5bd4d3cc.jpg";